import { AppConstant } from "../constant/AppConstant";

export const getLocalStorage = (key: string) => {
    return localStorage.getItem(key);
};

export const setLocalStorage = (key: string, value: any) => {
    localStorage.setItem(key, value);
};

export const removeItemLocalStorage = (key: string) => {
    localStorage.removeItem(key);
};

export const clearUserStorage = () => {
    removeItemLocalStorage(AppConstant.loginId);
    removeItemLocalStorage(AppConstant.authToken);
    removeItemLocalStorage(AppConstant.userName);
    removeItemLocalStorage(AppConstant.userEmail);
};

export const clearLocalStorage = () => {
    localStorage.clear();
    sessionStorage.clear();
};

export const setApiDataToCache = (key: string, value: any) => {
    const jsonData = JSON.stringify(value);
    localStorage.setItem(key, jsonData);
};

export const getApiDataToCache = (key: string,): any | null => {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null;
};
